/* eslint no-unused-vars: 0 */
import { extractHostname } from "/Assets/js/utilities.js";

class UtmTracking {
    constructor(options = {}) {
        this._cookieNamePrefix = "_hyp_";
        this._domain = options.domain;
        this._secure = options.secure || false;
        this._initialUtmParams = options.initialUtmParams || false;
        this._cookieExpiryMinutes = options.cookieExpiryMinutes || 30;
        this._utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
        this._utmInheritingDomains = ["onfastspring.com"];
        this.writeInitialReferrer();
        this.writeLastReferrer();
        this.writeInitialLandingPageUrl();
        if (this._initialUtmParams) {
            this.writeInitialUtmCookieFromParams();
        }
        if (this.utmPresentInUrl()) {
            this.writeUtmCookieFromParams();
        }

        return;
    }

    createCookie(name, value, minutes, path, domain, secure) {
        var cookieDomain, cookieExpire, cookiePath, cookieSecure, date, expireDate;
        expireDate = null;
        if (minutes) {
            date = new Date();
            date.setTime(date.getTime() + minutes * 60 * 1000);
            expireDate = date;
        }
        cookieExpire = expireDate != null ? "; expires=" + expireDate.toUTCString() : "";
        cookiePath = path != null ? "; path=" + path : "; path=/";
        cookieDomain = domain != null ? "; domain=" + domain : "";
        cookieSecure = secure ? "; secure" : "";
        document.cookie =
            this._cookieNamePrefix +
            name +
            "=" +
            escape(value) +
            cookieExpire +
            cookiePath +
            cookieDomain +
            cookieSecure;
    }

    readCookie(name) {
        var c, ca, i, nameEQ;
        nameEQ = this._cookieNamePrefix + name + "=";
        ca = document.cookie.split(";");
        i = 0;
        while (i < ca.length) {
            c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }

            i++;
        }
        return null;
    }

    eraseCookie(name) {
        this.createCookie(name, "", -1, null, this._domain, this._secure);
    }

    getParameterByName(name) {
        var regex, regexS, results;
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        regexS = "[\\?&]" + name + "=([^&#]*)";
        regex = new RegExp(regexS);
        results = regex.exec(window.location.search);
        if (results) {
            return decodeURIComponent(results[1].replace(/\+/g, " "));
        } else {
            return "";
        }
    }

    utmPresentInUrl() {
        var j, len, param, ref;
        ref = this._utmParams;
        for (j = 0, len = ref.length; j < len; j++) {
            param = ref[j];
            if (this.getParameterByName(param)) {
                return true;
            }
        }
        return false;
    }

    writeCookie(name, value) {
        this.createCookie(name, value, this._cookieExpiryMinutes, null, this._domain, this._secure);
    }

    writeCookieOnce(name, value) {
        var existingValue;
        existingValue = this.readCookie(name);
        if (!existingValue) {
            this.writeCookie(name, value);
        }
    }

    writeUtmCookieFromParams() {
        var j, len, param, ref, value;
        ref = this._utmParams;
        for (j = 0, len = ref.length; j < len; j++) {
            param = ref[j];
            value = this.getParameterByName(param);
            this.writeCookie(param, value);
        }
    }

    writeInitialUtmCookieFromParams() {
        var j, len, name, param, ref, value;
        ref = this._utmParams;
        for (j = 0, len = ref.length; j < len; j++) {
            param = ref[j];
            name = "initial_" + param;
            value = this.getParameterByName(param) || "";
            this.writeCookieOnce(name, value);
        }
    }

    appendUtmParametersToExternalLinks() {
        var j, len, links, tl, tp, nl;
        links = document.getElementsByTagName("a");
        for (j = 0, len = links.length; j < len; j++) {
            (tl = links[j].href), tp;
            if (this._isInheritingDomain(tl)) {
                nl = this.appendUtmParameters(tl);
                links[j].href = nl;
            }
        }
    }

    appendUtmParameters(link) {
        var j, len, param, ref, value, url;
        ref = this._utmParams;
        url = new URL(link);
        for (j = 0, len = ref.length; j < len; j++) {
            param = ref[j];
            value = this.getParameterByName(param) || this.readCookie(param) || null;
            if (value != null) {
                url.searchParams.append(param, value);
            }
        }
        return url.toString();
    }

    _isInheritingDomain(link) {
        var j, len, m;
        m = false;
        for (j = 0, len = this._utmInheritingDomains.length; j < len; j++) {
            if (link.indexOf(this._utmInheritingDomains[j]) > 0) {
                m = true;
            }
        }
        return m;
    }

    _sameDomainReferrer(referrer) {
        var hostname;
        hostname = document.location.hostname;
        return referrer.indexOf(this._domain) > -1 || referrer.indexOf(hostname) > -1;
    }

    _isInvalidReferrer(referrer) {
        return referrer === "" || referrer === void 0;
    }

    writeInitialReferrer() {
        var value;
        value = document.referrer;
        if (this._isInvalidReferrer(value)) {
            value = "direct";
        }
        this.writeCookieOnce("referrer", value);
    }

    writeLastReferrer() {
        var value;
        value = document.referrer;
        if (!this._sameDomainReferrer(value)) {
            if (this._isInvalidReferrer(value)) {
                value = "direct";
            }
            this.writeCookie("last_referrer", value);
        }
    }

    writeInitialLandingPageUrl() {
        var value;
        value = this.cleanUrl();
        if (value) {
            this.writeCookieOnce("initial_landing_page", value);
        }
    }

    initialReferrer() {
        return this.readCookie("referrer");
    }

    lastReferrer() {
        return this.readCookie("last_referrer");
    }

    initialLandingPageUrl() {
        return this.readCookie("initial_landing_page");
    }

    utmSource() {
        return this.readCookie("utm_source");
    }

    utmMedium() {
        return this.readCookie("utm_medium");
    }

    utmCampaign() {
        return this.readCookie("utm_campaign");
    }

    cleanUrl() {
        var cleanSearch;
        cleanSearch = window.location.search
            .replace(/utm_[^&]+&?/g, "")
            .replace(/&$/, "")
            .replace(/^\?$/, "");
        return (
            window.location.origin + window.location.pathname + cleanSearch + window.location.hash
        );
    }
}

var hostname = extractHostname(window.location.href, true).toLowerCase();
var utmTracking = new UtmTracking({
    domain: hostname,
    secure: true
});

export default utmTracking;
